import { MedicalPaOrdersAuthStatus } from "../../../../../enums/medicalPaOrdersAuthStatus";
import { ModalId } from "../../../../../enums/modalId";
import { setOpenedModalId } from "../../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../../redux/store/store";

export const checkIfNewDataIsForAuthReviewStatus = (
  newData: {
    bgColor: string;
    text: string;
    textColor: string;
    currentStatusId: string;
  },
  dispatch: AppDispatch,
) => {
  if (newData.currentStatusId === MedicalPaOrdersAuthStatus.AuthReview) {
    dispatch(
      setOpenedModalId({
        id: ModalId.DRAFT_SUBMISSION_MODAL,
      }),
    );
    return true;
  }
  return false;
};
